import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import DetailRow from '../../policy_feature/DetailRow'
import ModalBody from './ModalBody'
import ModalFooter from './ModalFooter'
import ModalHeader from './ModalHeader'
import SelectedTemplatesView from './SelectedTemplatesView'

const propTypes = {
  /**
   * Callback called when close button is clicked
   */
  onHide: PropTypes.func.isRequired,
  /**
   * map of form options that are non tenant specific
   */
  globalFormOptionsMap: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Selected template group object
   */
  selectedTemplateGroup: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback when the edit button is clicked
   */
  onEditClick: PropTypes.func.isRequired,
}

const defaultProps = {
  globalFormOptionsMap: {},
}

const isAugmenttDefault = (group) => !group.organization_id

function TemplateGroupView(props) {
  const { onHide, globalFormOptionsMap, selectedTemplateGroup, onEditClick } = props

  return (
    <>
      <ModalHeader
        title={
          <>
            {selectedTemplateGroup?.name}&nbsp;
            <span className="text-color-secondary text-lowercase">
              (<FormattedMessage id="POLICY_TEMPLATES.BASELINE" />)
            </span>
          </>
        }
      />

      <ModalBody>
        <DetailRow label="POLICY_GROUP.BASELINE_NAME" value={selectedTemplateGroup?.name} />
        <DetailRow label="POLICY_TEMPLATES.DESCRIPTION" value={selectedTemplateGroup?.description} />
        <hr className="mb-4 mt-0" />

        <SelectedTemplatesView
          selectedTemplates={selectedTemplateGroup?.templates}
          globalFormOptionsMap={globalFormOptionsMap}
        />
      </ModalBody>

      <ModalFooter
        onHide={onHide}
        closeButtonLabel="GENERAL.CLOSE"
        primaryButtonLabel="POLICY_GROUP.EDIT_BASELINE"
        onPrimaryButtonClick={onEditClick}
        hidePrimaryButton={isAugmenttDefault(selectedTemplateGroup)}
      />
    </>
  )
}

TemplateGroupView.propTypes = propTypes
TemplateGroupView.defaultProps = defaultProps

export default TemplateGroupView
